import type {CurrentThreadPositioning, ThreadPositioning, ThreadSubjectType} from '../conversation-types'

/**
 * Normalizes subject type values from the various thread and comment sources (e.g. `line`, `MULTILINE`, `FILE`).
 * Multiline threads are considered line threads.
 */
export function toThreadSubjectType(subjectType: string | null | undefined): ThreadSubjectType | undefined {
  switch (subjectType?.toUpperCase()) {
    case 'FILE':
      return 'FILE'
    case 'LINE':
    case 'MULTILINE':
      return 'LINE'
    default:
      return undefined
  }
}

export function threadPositioningToCurrentPositioning(positioning: ThreadPositioning): CurrentThreadPositioning {
  return {
    path: positioning.path,
    startLine: positioning.startLine ?? null,
    startDiffSide: positioning.startDiffSide ?? null,
    endLine: positioning.endLine ?? null,
    endDiffSide: positioning.endDiffSide ?? null,
    isOutdated: positioning.isOutdated,
  }
}

export function fileCurrentPositioning(path: string, isOutdated: boolean): CurrentThreadPositioning {
  return {
    path,
    startLine: null,
    startDiffSide: null,
    endLine: null,
    endDiffSide: null,
    isOutdated,
  }
}
